import { z } from "zod";

import { DraftReplies } from "@/enum/draft-replies.enum";
import { SubscriptionSchema } from "@/pages/Private/pages/Subscription/schema/subscription";

export const CompanySchema = z.object({
	id: z.number().gt(0),
	name: z.string(),
	linkedinUrl: z.string().nullable(),
	apolloApiKey: z.string().nullable(),
	lemlistApiKey: z.string().nullable(),
	hasApolloApiKey: z.boolean(),
	hasLemlistApiKey: z.boolean(),
	hasHubspotApiKey: z.boolean(),
	website: z.string().nullable(),
	personas: z.array(z.string()).nullable(),
	industries: z.array(z.string()).nullable(),
	fromOrganization: z.object({
		urn: z.string().nullable(),
		image: z.string().nullable(),
		subtitle: z.string().nullable(),
		title: z.string().nullable(),
	}),
	fromMember: z.object({
		urn: z.string().nullable(),
		image: z.string().nullable(),
		title: z.string().nullable(),
		subtitle: z.string().nullable(),
	}),
	keywords: z.string().nullable(),
	stripeCustomerId: z.string().nullable(),
	stripeSubscriptionId: z.string().nullable(),
	isOnboarded: z.boolean(),
	subscriptions: z.array(SubscriptionSchema).nullable(),
	demoEndsAt: z.string().nullable(),
	demoEndsInDays: z.number().nullable(),
	isDemo: z.boolean(),
	size: z.string().nullable(),
	location: z.string().nullable(),
	bought5Lists: z.boolean(),
	draftReplies: z.nativeEnum(DraftReplies).nullable(),
});

export const UpdateCompanySchema = z.object({
	name: z.string(),
	linkedinUrl: z.string().optional(),
	website: z.string().optional(),
	personas: z.array(z.string()).optional(),
	industries: z.array(z.string()).optional(),
	fromOrganization: z.object({
		urn: z.string().optional(),
		image: z.string().optional(),
		name: z.string().optional(),
	}),
	fromMember: z.object({
		urn: z.string().optional(),
		image: z.string().optional(),
		title: z.string().optional(),
		subtitle: z.string().optional(),
	}),
	keywords: z.string().optional(),
});

export const UpdateCompanyInSettingsSchema = z.object({
	name: z.string(),
	linkedinUrl: z.string().optional(),
	website: z.string().optional(),
	draftReplies: z.nativeEnum(DraftReplies).nullable().optional(),
});

export const SaveApiKeysCompanySchema = z.object({
	apolloApiKey: z.string().optional(),
	lemlistApiKey: z.string().optional(),
	hubspotApiKey: z.string().optional(),
});

export type CompanyType = z.infer<typeof CompanySchema>;
export type UpdateCompany = z.infer<typeof UpdateCompanySchema>;
export type UpdateCompanyInSettings = z.infer<typeof UpdateCompanyInSettingsSchema>;
export type SaveApiKeysCompany = z.infer<typeof SaveApiKeysCompanySchema>;
